import React, { useState } from "react";

import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

import Button from "components/Button";

import { InvoiceTabs } from "./InvoiceTabs";

import { ReactComponent as CloseIcon } from "assets/images/icon_close_modal.svg";
import { ReactComponent as SuccessCheck } from "assets/images/success-check.svg";

import { useAppDispatch } from "store/hooks";
import { setNotification } from "store/features/notificationSlice";

import { styles } from "./styles";

export enum InvoiceTabId {
  Message = "message",
  QrCode = "qrCode",
}

export const invoiceTabs = [
  {
    id: InvoiceTabId.Message,
    label: "Платіжне посилання",
  },
  {
    id: InvoiceTabId.QrCode,
    label: "QR-код",
  },
];

interface SuccessModalProps {
  isOpen: boolean;
  ibanInvoiceUrl: string | null;
  onClose: () => void;
}

const SuccessModal: React.FC<SuccessModalProps> = (props) => {
  const { isOpen, ibanInvoiceUrl, onClose } = props;
  const dispatch = useAppDispatch();

  const [visibleTab, setVisibleTab] = useState<InvoiceTabId>(
    InvoiceTabId.Message,
  );

  const onCloseModal = () => {
    onClose();
    setVisibleTab(InvoiceTabId.Message);
  };

  const onCopy = async () => {
    try {
      ibanInvoiceUrl && (await navigator.clipboard.writeText(ibanInvoiceUrl));

      onCloseModal();
      dispatch(
        setNotification({
          message: "Посилання скопійоване",
          severity: "success",
        }),
      );
    } catch (err) {
      dispatch(
        setNotification({ message: "Помилка копіювання", severity: "error" }),
      );
    }
  };

  const onGoToLink = () => {
    ibanInvoiceUrl && window.open(ibanInvoiceUrl, "_blank");
  };

  const renderModalText = () => {
    switch (visibleTab) {
      case InvoiceTabId.Message:
        return "Надішліть його клієнту для оплати.";
      case InvoiceTabId.QrCode:
        return "Клієнт може відсканувати цей QR-код для оплати.";
      default:
        return "Надішліть його клієнту для оплати.";
    }
  };

  const renderModalButton = () => {
    const messageButtons = (
      <>
        <Button
          sx={{ mb: 2 }}
          color="primary"
          variant="contained"
          fullWidth
          onClick={() => onCopy()}
        >
          Скопіювати та закрити
        </Button>
        <Button
          variant="contained"
          color="secondary"
          fullWidth
          onClick={() => onGoToLink()}
        >
          Переглянути посилання
        </Button>
      </>
    );

    const qrButtons = (
      <>
        <Button
          sx={{ mb: 2 }}
          color="primary"
          variant="contained"
          fullWidth
          onClick={() => onCloseModal()}
        >
          Закрити
        </Button>
        <Button
          variant="contained"
          color="secondary"
          fullWidth
          onClick={() => onGoToLink()}
        >
          Переглянути посилання
        </Button>
      </>
    );

    switch (visibleTab) {
      case InvoiceTabId.Message:
        return messageButtons;
      case InvoiceTabId.QrCode:
        return qrButtons;
      default:
        return messageButtons;
    }
  };
  return (
    <Dialog
      open={isOpen}
      onClose={onCloseModal}
      slotProps={{ paper: { sx: styles.modal } }}
    >
      <IconButton
        aria-label="close-modal"
        onClick={onCloseModal}
        sx={styles.closeButton}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={styles.content}>
        <Box sx={styles.contentWrapper}>
          <SuccessCheck />
          <Typography variant="h5" sx={{ mt: 2, mb: 0.5 }}>
            Ваше платіжне посилання створено
          </Typography>
          <Typography sx={{ mb: 2 }} color="grey700">
            {renderModalText()}
          </Typography>
          <InvoiceTabs
            invoiceUrl={ibanInvoiceUrl}
            visibleTab={visibleTab}
            setVisibleTab={setVisibleTab}
          />

          {renderModalButton()}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessModal;
